import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface EducationQueryRequest {
  filters: {
    course: string;
    country?: string;
    universities: string[];
  };
  query: string;
}

export interface OverviewResponse {
  composite_score: {
    value: number;
    label: string;
    color: string;
    brand: string;
  };
  competitor_analysis: {
    title: string;
    subtitle: string;
    series: ChartSeries[];
    x_axis: string[];
    y_axis: string;
    chart_type: string;
  };
  performance_table: PerformanceTableRow[];
  references: {
    methodology: string;
    sources: Source[];
    last_updated: string;
  };
  metadata: {
    response_time: number;
    universities_analyzed: number;
    data_source: string;
    course: string;
    your_brand: string;
    competitors: string[];
    timestamp: string;
  };
}

export interface ChartSeries {
  name: string;
  data: number[];
  type: string;
  color?: string;
}

export interface ChartDataPoint {
  name: string;
  value: number;
  type: string;
  color: string;
}

export interface PerformanceTableRow {
  university: string;
  is_your_brand: boolean;
  teaching_quality: number;
  academic_reputation: number;
  placement_rate: number;
  international_outlook: number;
  resources_infrastructure: number;
  industry_knowledge_transfer: number;
  fees: string;
  rankings: string;
}

export interface Source {
  title: string;
  url: string;
  confidence: number;
}

@Injectable({
  providedIn: 'root'
})
export class EducationOverviewService {
  private apiUrl = environment.apiUrl || 'http://localhost:8000';

  constructor(private http: HttpClient) { }

  getOverviewAnalysis(request: EducationQueryRequest): Observable<OverviewResponse> {
    return this.http.post<OverviewResponse>(`${this.apiUrl}/education/overview/analysis`, request);
  }
}
